import { createReducer, on } from '@ngrx/store';
import { consumerPortalDefaults } from '../../../../input-config/consumer-portal-config';
import { ConsumerPortalConfig } from '../../../models';
import { setConfig } from './config.actions';

export interface ConfigState {
    config: ConsumerPortalConfig;
}

export const initialConfigState: ConfigState = {
    config: consumerPortalDefaults
};

export const configReducer = createReducer(
    initialConfigState,
    on(setConfig, (state: ConfigState, { config }: { config: ConsumerPortalConfig }) => {
        return { ...state, config: { ...config } };
    })
);
